@if (reversalExists) {
    <show-message [type]="messageType.INFO" class="reversal-container">
        <div info class="reversal-notification">
            <strong>
                {{
                    'PARTY.CASHIER.web.deposit.pending.withdrawal' | translate: { amount: totalReversals?.amount | vnCurrency: totalReversals?.code }
                }}
            </strong>
            <a class="reversal-link" (click)="gotoWithdrawal()" id="gotoWithdrawal">{{ 'PARTY.CASHIER.web.deposit.goto.withdrawal' | translate }}</a>
        </div>
    </show-message>
}
